<template>
    <div class="flatpickr-wrapper">
		<div class="input-container">
			<input
            	ref="flatpickr"
				v-bind="$attrs"
				class="dates-input"
				readonly
			>
			<v-icon
				class="calendar-icon"
				color="success"
				@click="openFlatpickr">event</v-icon>
		</div>
    </div>
</template>

<script>
import { subHours } from 'date-fns';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/l10n/es';

function mounted() {
	this.initFlatPickr();
}

function created() {
	// this.initFlatPickr();
}

function initFlatPickr() {
	const options = {
		dateFormat: this.dateFormat,
		enableTime: this.enableTime,
		locale: 'es',
		defaultDate: this.defaultDate || null,
		onChange: (selectedChange) => {
			if (selectedChange.length > 0) {
				this.date = selectedChange[0];
				const formattedDate = this.date.toISOString().replace('T', ' ').replace(/\.\d+Z$/, '');
				const finalDate = subHours(formattedDate, 5);
				this.$emit('input', finalDate);
			} else {
				this.$emit('input', null);
			}
		},
	};
	if (this.blockFutureDates) {
		options.maxDate = new Date();
	}

	this.fpInstance = flatpickr(this.$refs.flatpickr, options);
}

function openFlatpickr() {
	this.$refs.flatpickr.flatpickr.open();
}

function data() {
	return {
	};
}

export default {
	name: 'app-date-flat',
	data,
	mounted,
	created,
	methods: {
		initFlatPickr,
		openFlatpickr,
	},
	props: {
		defaultDate: {
			type: String,
			default: null,
		},
		dateFormat: {
			type: String,
			default: 'Y-m-d H:i',
		},
		enableTime: {
			type: Boolean,
			default: true,
		},
		blockFutureDates: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		defaultDate(newDate, oldDate) {
			if (newDate !== oldDate) {
				this.fpInstance.setDate(newDate || null);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.flatpickr-wrapper {
	width: 100%;
	label {
		font-size: size(small);
	}
	&:hover {
		border: 1px solid map-get($colors , green-light);
	}
}
.input-container {
	position: relative;
	display: inline-block;
	width: 100% !important;
}
.calendar-icon {
	position: absolute;
	top: 55%;
	right: 5px;
	transform: translateY(-50%);
	pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-date-flat.vue